// gorgias-chat-init.js
GorgiasChat.init().then(function () {
    // Set custom business hours for chat availability
    GorgiasChat.setCustomBusinessHours({
      timezone: "Europe/London", // Timezone from tz database
      businessHours: [
        { days: [1, 2, 3, 4], fromTime: "09:30", toTime: "16:30" },
        { days: [5, 6], fromTime: "10:00", toTime: "17:00" },
        { days: [7], fromTime: "11:00", toTime: "15:00" }
      ]
    });
  });